import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

//actions:
import { openDialog, hideDialog } from '../actions/index';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

//components:
import { getData } from '../dataLib';
import NeuriteGrid from '../components/neurite_grid';
import { RepeatOneSharp } from '@material-ui/icons';

const styles = theme => ({
    root: {
        margin: 10
    },
    spinnerContainer: {
        width: 250,
        height: 220,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class ReportList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            reports: [],
            isLoading: true,
        };
    };

    getReports = () => {
        getData(
            (this.props.kd ? 'NaReport/KD' : 'NaReport')+'?i_group=' + this.props.group + '&i_profile=' + this.props.userProfile.selectedCentroProfile.iPerfil,
            (response) => {
                
                if (this.props.user.profile.sub === '25' || this.props.user.profile.sub === '795') //si no es la meli filtramos para que no salga el report 64
                {
                    this.setState({ ...this.state, reports: response.data, isLoading: false });
                }
                else {                    
                    this.setState({ ...this.state, reports: response.data.filter(r => r.id !== 64), isLoading: false });
                }
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching reports ' + error
                }, 'error-fetching-report-definition', false, 'sm');
                this.setState({ ...this.state, isLoading: false });
            },
            this.props.user,
        );
    };


    componentDidMount = () => {
        this.getReports();
    }

    render() {
        const { classes } = this.props;

        //const perfil = this.props.userProfile.selectedCentroProfile ? this.props.userProfile.selectedCentroProfile.iPerfil : 100;

        //const reports = this.state.reports.filter(r => r.iLevel >= perfil);
        const reports = this.state.reports;

        return (
            <div className={classes.root}>

                {!this.state.isLoading ?
                    <div>
                        {reports.length ?
                            <NeuriteGrid
                            id="r_l"
                                columns={[
                                    { key: 'descr', name: 'Informe', editable: false, dragable: false, width: 300 },
                                    {
                                        key: 'launch', name: '', editable: false, dragable: false, type: 'launch', handleLaunchClick: (row) => {
                                            const hasIdList = (row.id === 33 || row.id === 34 || row.id === 43);
                                            if (row.id === 27) {
                                                this.props.openDialog('ReportRankingMaquinas', {
                                                    reportId: row.id,
                                                    hasIdList: hasIdList
                                                }, 'report_ranking_maquinas', false, 'sm');
                                            }
                                            else if (row.id === 52) {
                                                this.props.openDialog('ReportRegalosEntregados', {
                                                    reportId: row.id,
                                                    hasIdList: hasIdList
                                                }, 'report_regalos_entregados', false, 'sm');
                                            }
                                            else {
                                                this.props.openDialog('ReportGeneric', {
                                                    reportId: row.id,
                                                    hasIdList: hasIdList
                                                }, 'report_generic_' + row.id, false, 'sm');
                                            }

                                        }
                                    },
                                ]}
                                rows={reports}
                                buttonEdit={false}
                                buttonDelete={false}
                                buttonNew={false}
                                enableSelection={false}
                                height={500}
                            />

                            : ''}
                    </div>
                    :
                    <div className={classes.spinnerContainer}>
                        <CircularProgress className={classes.spinner} color="primary" />
                    </div>
                }

            </div>
        );
    };
};


ReportList.propTypes = {
    //state
    user: PropTypes.object,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    //parameters
    group: PropTypes.number.isRequired

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        userProfile: state.userProfile,
        kd : state.userProfile.kd,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        hideDialog,
        openDialog
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(ReportList));